<div style="display:flex; justify-content: space-between; column-gap: 80px;">
    <div>
        <h2 mat-dialog-title translate><span translate>PRODUCTS.IMPROVEMENT</span> NR.{{ improvement.ProjImprID }} {{ improvement[localizedFields.get('Description')].toUpperCase() }}</h2>
    </div>
    <div>
        <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
    </div>
</div>

<mat-dialog-content>
    <p class="improvement-data-title mt-2rem" *ngIf="improvement.ProjImprFatherID != 0"><span translate>Progetto padre</span>:</p>
    <p class="improvement-text" *ngIf="improvement.ProjImprFatherID != 0">
        <button mat-button (click)="onButtonClick()">
            {{ improvement.ProjImprFatherID }}
        </button>
    </p>

    <mat-divider *ngIf="getNeeds(improvement)"></mat-divider>
    <p class="improvement-data-title mt-2rem"><span translate>COMMONS.PRODUCTS</span>:</p>
    <p class="improvement-text" *ngFor="let product of getDevelopedForProducts(improvement)">- {{ product }}</p>

    <mat-divider *ngIf="getNeeds(improvement)"></mat-divider>
    <p class="improvement-data-title mt-2rem" *ngIf="getNeeds(improvement)"><span translate>PRODUCTS.NEEDS</span>:</p>
    <p class="improvement-text">{{ getNeeds(improvement) }}</p>

    <mat-divider *ngIf="getRequirements(improvement)"></mat-divider>
    <p class="improvement-data-title mt-2rem" *ngIf="getRequirements(improvement)"><span translate>PRODUCTS.REQUIREMENTS</span>:</p>
    <p class="improvement-text">{{ getRequirements(improvement) }}</p>

    <mat-divider *ngIf="archiviedDocuments?.length > 0"></mat-divider>
    <p class="improvement-data-title mt-2rem" *ngIf="archiviedDocuments?.length > 0"><span translate>Allegati</span>:</p>
    <button *ngFor="let archiviedDocument of archiviedDocuments" mat-button (click)="downloadArchiviedDocument(archiviedDocument)" color="primary">
        <mat-icon>download</mat-icon>
        {{ archiviedDocument.Name }}
    </button>
</mat-dialog-content>
<div *ngIf="isLoading">
    <tb-loading></tb-loading>
</div>
